import React, { useState, useEffect, useContext, useMemo } from "react";
import _ from "lodash";
import axios from "axios";
import styled from "styled-components";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import UploadMaterial from "./UploadMaterial";
//import useActionTable from "../useActionTable.js";

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);
  const [newMaterial, setNewMaterial] = useState({ id: " ", name: " " });

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([{ id: " ", name: " " }]);
  const [filteredStructureData, setFilteredStructureData] = useState([
    { id: " ", name: " " },
  ]);
  const [materialsIds, setMaterialsIds] = useState([]);
  //console.log(materialsIds);

  const refreshTable = (newMaterial) => {
    setNewMaterial(newMaterial);
  };

  useEffect(() => {
   // console.log("refreshTable", structureData, newMaterial);
    filteringData([...structureData, newMaterial]);
    setMaterialsIds([...materialsIds, newMaterial.id]);
  }, [newMaterial]);

  useEffect(() => {
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          materials: filteredStructureData,
        },
      },
    }));
  }, [filteredStructureData]);

//  console.log(results, filteredStructureData, structureData, action);

  useEffect(() => {
    getStructureData("structure.walls.materials");
  }, [isRefetched]);

  useEffect(() => {
    let materialsIdsFlat = [...materialsIds].flat();
    const uniqueIds = [...new Set(materialsIdsFlat)];

    const result = structureData.filter(({ id }) => uniqueIds.includes(id));
    console.log(uniqueIds, structureData, result);
    return setFilteredStructureData(result);
  }, [materialsIds, structureData]);

  useEffect(() => {
    action.parameters.impact.walls !== undefined &&
      setMaterialsIds(
        action.parameters?.impact?.walls.map((wall) => {
          return wall?.materials.map((material) => {
            return material.uuid;
          });
        })
      );
  }, [JSON.stringify(action.parameters?.impact?.walls)]);

  function filteringData(data) {
    console.log(data);
    const allowed = [
      "name",
      "uuid",
      "id",
      "category",
      "walltype",
      "thickness",
      "thermicalresistance",
      "umaterial",
      "unitcost",
    ];

    const filteredData = [];
    data.map((wall) => {
      const filteredObj = _.pick(wall, allowed);
      filteredData.push(filteredObj);
    });

    const newKeys = { uuid: "id" };

    const replacedUuidWithIdName = [];

    filteredData.map((wall) => {
      const renamedObj = renameKeys(wall, newKeys);
      replacedUuidWithIdName.push(renamedObj);
    });

    console.log(replacedUuidWithIdName);

    setStructureData(replacedUuidWithIdName);
  }

  const UploadComponent = ({ onUpload }) => (
    <UploadButton type="button" onClick={onUpload}>
      <UploadMaterial
        onClick={onUpload}
        refetch={refreshTable}
        setFilteredStructureData={setFilteredStructureData}
        //setLoading={setLoading}
      />
    </UploadButton>
  );

  const getStructureData = async (route) => {
    let data = [];
    let materials = action.parameters?.impact?.materials || [];
    let walls = action.parameters?.impact?.walls;

    let materialsIds2 = [];

    if (walls !== undefined) {
      materialsIds2 = action.parameters?.impact?.walls.map((wall) => {
        return wall?.materials.map((material) => {
          return material.uuid;
        });
      });
    }

    const uniqueIds = [...new Set(materialsIds2)];
    let materialsIdsFlat = [...uniqueIds].flat();

    await axios
      .get(getSite(action.parameters.general.groups[0], route), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        data = res?.data?.detail?.structure?.walls?.materials || [];
      });
    if (materials.length !== 0 || data.length !== 0) {
      filteringData([
        ...data.filter((obj) => !materialsIdsFlat.includes(obj.uuid)),
        ...materials,
      ]);
    }
  };

  function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  const TableName = styled.div`
    margin-right: auto;
    margin-left: -8px;
    font-size: 1.3rem;
    font-weight: 500;
  `;

  // ----------------------------------------------------------

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName>Liste de matériaux</TableName>
        {actionplanupdate && (
          <UploadComponent key="UploadComponent" onUpload={handleClear} />
        )}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const UploadButton = styled.div`
    margin-left: 15px;
    &:hover {
      cursor: pointer;
    }
  `;

  // const filteredItems = _.get(results, "actions", []);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredStructureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    // refreshTable,
  };
}
